import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { intelliegenceContext } from "../../../states/context/intelliegenceContext";
import { updateFitBounds } from "../../../utils/map";
import Icon from "@material-ui/core/Icon";
import { getIconName } from "../../../utils/map";
import moment from "moment-timezone";

const NewsComponent = (props) => {
  const context = useContext(intelliegenceContext);
  const styles = useStyles();
  const news = context.markerLocation.filter((markerInfo) => markerInfo.marker_type === "news").map((news) => {
      news.icon = getIconName(news.data.category);
      return news;
    });

  const viewOnMap = async (data) => {
    let zoom = 4;
    const _markerData = context.markerLocation;
    const activeIndex = _markerData.findIndex(
      (marker) => marker.lat === data.lat && marker.lng === data.lng
    );

    context.setActiveMarkerId(activeIndex);
    context.setInfoWindowIsShow(true);

    await updateFitBounds([data]);
    // context.setZoomLevel(7); // to do set zoom not working
    if (data.marker_priority === 2) zoom = 6;
    if (data.marker_priority === 3) zoom = 7;
    const _drawer = context.drawer;
    _drawer.news = false;

    context.setDrawer(_drawer);

    const _markers = context.markerLocation.map((marker) => {
      if (data.lat === marker.lat && data.lng === marker.lng) {
        marker.hover = false;
      }
      return marker;
    });
    context.setMarkerLocation(_markers);

    // context.setMapLocation({ lat: data.lat, lng: data.lng });
    // window.intelliegenceMap.current.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.setZoom(
    //   zoom
    // );
  };

  const onMouseEnterNews = (e) => {
    const _markers = context.markerLocation.map((marker) => {
      if (e.lat === marker.lat && e.lng === marker.lng) {
        marker.hover = true;
      }
      return marker;
    });
    context.setMarkerLocation(_markers);
  };

  const onMouseLeaveNews = (e) => {
    const _markers = context.markerLocation.map((marker) => {
      if (e.lat === marker.lat && e.lng === marker.lng) {
        marker.hover = false;
      }
      return marker;
    });
    context.setMarkerLocation(_markers);
  };
  return (
    <React.Fragment>
      {news.map((newsInfo, i) => {
        let label = "Potential Global Risk";
        if (newsInfo.data.affected === "N/A") {
          if (newsInfo.data.category.toUpperCase().startsWith("ESG"))
            label = "ESG Risk";
        }
        return (
          <React.Fragment key={i}>
            {context.drawer.news && (
              <Grid
                item
                xs={12}
                className={styles.newsCard}
                onMouseEnter={() => onMouseEnterNews(newsInfo)}
                onMouseLeave={() => onMouseLeaveNews(newsInfo)}
                onClick={() => viewOnMap(newsInfo)}
              >
                <Card className={styles.root}>
                  <CardContent>
                    <Grid style={{display: "fit-content"}}>
                      <React.Fragment>
                        <Grid item xs={2} style={{minWidth: "fit-content"}}>
                          <div className={styles.circle}>
                            <Icon>{newsInfo.icon}</Icon>
                          </div>
                        </Grid>
                        <Grid
                          item
                          xs={10}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Typography className={styles.title} gutterBottom>
                            {newsInfo.data.news}
                          </Typography>{" "}
                        </Grid>
                      </React.Fragment>

                    </Grid>
                    <Typography className={styles.pos} color="textSecondary">
                      {newsInfo.data.source_name} | {newsInfo.data.category} |{" "}
                      {moment.utc(newsInfo.data.event_timestamp).fromNow()}
                    </Typography>
                    {newsInfo.data.affected === "N/A" && (
                      <Typography
                        variant="body2"
                        component="p"
                        className={styles.content}
                      >
                        {label}
                      </Typography>
                    )}
                    {newsInfo.data.affected !== "N/A" &&
                      newsInfo.data.port_affected === "N/A" && (
                        <Typography
                          variant="body2"
                          component="p"
                          className={styles.content}
                        >
                          <span>
                            {newsInfo.data.affected}{" "}
                            {newsInfo.data.affected > 1
                              ? "supplier(s)"
                              : "supplier"}{" "}
                          </span>{" "}
                          in Tier {newsInfo.data.supplier_tier} at risk
                        </Typography>
                      )}
                    {newsInfo.data.affected === "N/A" &&
                      newsInfo.data.port_affected !== "N/A" && (
                        <Typography
                          variant="body2"
                          component="p"
                          className={styles.content}
                        >
                          <span>
                            {newsInfo.data.port_affected}{" "}
                            {newsInfo.data.port_affected > 1
                              ? "port(s)"
                              : "port"}{" "}
                          </span>{" "}
                          at risk
                        </Typography>
                      )}
                    {newsInfo.data.affected !== "N/A" &&
                      newsInfo.data.port_affected !== "N/A" && (
                        <Typography
                          variant="body2"
                          component="p"
                          className={styles.content}
                        >
                          <span>
                            {newsInfo.data.affected}{" "}
                            {newsInfo.data.affected > 1
                              ? "supplier(s)"
                              : "supplier"}{" "}
                          </span>{" "}
                          in Tier {newsInfo.data.supplier_tier} {"&"}{" "}
                          <span>
                            {newsInfo.data.port_affected}{" "}
                            {newsInfo.data.port_affected > 1
                              ? "port(s)"
                              : "port"}{" "}
                          </span>
                          at risk
                        </Typography>
                      )}
                    {/* {newsInfo.data.affected !== "N/A" && (
                      <Typography
                        variant="body2"
                        component="p"
                        className={styles.content}
                      >
                        <span>
                          {newsInfo.data.affected}{" "}
                          {newsInfo.data.affected > 1
                            ? "supplier(s)"
                            : "supplier"}{" "}
                        </span>
                        in Tier {newsInfo.data.supplier_tier}
                        at risk
                      </Typography>
                    )} */}
                  </CardContent>
                  {/* <CardActions>
                    <Button
                      variant="contained"
                      size="small"
                      className={styles.btn}
                      onClick={() => viewOnMap(newsInfo)}
                    >
                      View on Map
                    </Button>
                  </CardActions> */}
                </Card>
              </Grid>
            )}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: "0px",
  },
  newsCard: {
    cursor: "pointer",
    "& Button": {
      backgroundColor: "#4caf50",
      color: "#FFFFFF",
      fontSize: 12,
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "500",
    },
    "& .MuiButton-root:hover": {
      backgroundColor: "#4caf50",
    },
    "& .MuiCardActions-root": {
      padding: "0px 8px 8px 16px",
    },
    "& .MuiButton-root": {
      textTransform: "none",
    },
  },
  title: {
    fontSize: 12,
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "bold",
    letterSpacing: "0.2px",
  },
  pos: {
    fontSize: 12,
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "normal",
    letterSpacing: "0.2px",
  },
  content: {
    fontSize: 12,
    fontFamily: "Inter",
    letterSpacing: "0.2px",
    marginTop: 12,
    color: "#000000",
    "& span": {
      borderBottom: ".1px solid #000000",
    },
  },
  btn: {
    color: "black",
  },
  circle: {
    backgroundColor: "#fff",
    border: "2px solid #4caf50",
    borderRadius: "50%",
    mozBorderRadius: "50%",
    webkitBorderRadius: "50%",
    padding: "4px",
    height: "35px",
    width: "35px",
  },
}));

export default NewsComponent;
